import apiClient from "./apiClient";

export const api = {
    async get(url, haveParams = false, params = {}) {
        try {
            const queryString = haveParams ? `?${new URLSearchParams(params)}` : '';
            const response = await apiClient.get(`${url}${queryString}`);
            return response.data;
        } catch (error) {
            return {
                success: false,
                error: error.error || error.message
            };
        }
    },

    async post(url, body) {
        try {
            const data = Object.keys(body).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
            }).join('&');
            
            const response = await apiClient.post(url, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return {
                success: false,
                error: error.error || error.message
            };
        }
    },

    async put(url, body) {
        try {
            const response = await apiClient.put(url, body, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return {
                success: false,
                error: error.error || error.message
            };
        }
    },

    async delete(url, params) {
        try {
            const response = await apiClient.delete(`${url}/${params}`);
            return response.data;
        } catch (error) {
            return {
                success: false,
                error: error.error || error.message
            };
        }
    }
};

export default api;
